<template>
  <div class="plv-ia-loading">
    <div class="plv-ia-loading__inner"></div>
  </div>
</template>

<script>
export default {
  name: 'CommonLoading'
};
</script>

<style lang="scss">
.plv-ia-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: #ffffff;
  justify-content: center;
  align-items: center;
  z-index: 100;
  .plv-ia-loading__inner {
    height: 26px;
    width: 26px;
    border-radius: 100%;
    border: 2px solid #2196f3;
    border-bottom-color: rgba(0, 0, 0, 0);
    background: rgba(0, 0, 0, 0) !important;
    animation: loading-rotate 1s linear 0s infinite;
  }
}
@keyframes loading-rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(.6);
  }
  100% {
    transform: rotate(1turn) scale(1);
  }
}
</style>
